export default {
  xsDown: '(max-width: 575px)',
  smDown: '(max-width: 767px)',
  mdDown: '(max-width: 999px)',
  tabletUp: '(min-width: 768px) and (min-height: 500px)',
  hover: '(hover)',
};
